import api from '../api/client';
import React, { useState } from 'react';
import { Card, Form, Input, Select, Button, Row, Col, Typography, message } from 'antd';
import { SaveOutlined, ToolOutlined } from '@ant-design/icons';

const { Title } = Typography;
const { Option } = Select;

const FarmManagement = ({ farmData, onUpdate }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    React.useEffect(() => {
        if (farmData) {
            form.setFieldsValue(farmData);
        }
    }, [farmData, form]);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const response = await fetch('http://localhost:5000/api/farm-data', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ...values,
                    userId: 'default'
                })
            });

            const result = await response.json();

            if (result.success) {
                message.success('Farm data saved successfully!');
                onUpdate(); // Refresh data
            } else {
                message.error('Failed to save farm data');
            }
        } catch (error) {
            console.error('Error saving farm data:', error);
            message.error('Error saving farm data');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card
            title={
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <ToolOutlined style={{ marginRight: '8px' }} />
                    Farm Management
                </div>
            }
            bordered={false}
        >
            <Form form={form} layout="vertical" onFinish={onFinish} initialValues={farmData || {}}>
                <Row gutter={[24, 16]}>
                    <Col xs={24} md={12}>
                        <Form.Item name="name" label="Farm Name" rules={[{ required: true, message: 'Please enter farm name' }]}>
                            <Input placeholder="Enter farm name" />
                        </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                        <Form.Item name="size" label="Farm Size (acres)" rules={[{ required: true, message: 'Please enter farm size' }]}>
                            <Input type="number" placeholder="Enter size in acres" />
                        </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                        <Form.Item name="cropType" label="Primary Crop" rules={[{ required: true, message: 'Please select crop type' }]}>
                            <Select placeholder="Select crop type">
                                <Option value="wheat">Wheat</Option>
                                <Option value="corn">Corn</Option>
                                <Option value="rice">Rice</Option>
                                <Option value="soybean">Soybean</Option>
                                <Option value="vegetables">Vegetables</Option>
                                <Option value="fruits">Fruits</Option>
                                <Option value="other">Other</Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                        <Form.Item name="soilType" label="Soil Type" rules={[{ required: true, message: 'Please select soil type' }]}>
                            <Select placeholder="Select soil type">
                                <Option value="clay">Clay</Option>
                                <Option value="sandy">Sandy</Option>
                                <Option value="loam">Loam</Option>
                                <Option value="silt">Silt</Option>
                                <Option value="peat">Peat</Option>
                                <Option value="chalk">Chalk</Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                        <Form.Item
                            name="irrigationSystem"
                            label="Irrigation System"
                            rules={[{ required: true, message: 'Please select irrigation system' }]}
                        >
                            <Select placeholder="Select irrigation system">
                                <Option value="drip">Drip Irrigation</Option>
                                <Option value="sprinkler">Sprinkler System</Option>
                                <Option value="flood">Flood Irrigation</Option>
                                <Option value="center-pivot">Center Pivot</Option>
                                <Option value="manual">Manual</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item>
                    <Button type="primary" htmlType="submit" icon={<SaveOutlined />} loading={loading} size="large">
                        Save Farm Configuration
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    );
};

export default FarmManagement;
